import React from "react";
import { Box, Stack, Typography, TextField } from "@mui/material";

const DailyPicker = ({ values, set, errors }) => (
  <Box>
    <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "#475569", mb: 1.5 }}>
      Repeat every
    </Typography>
    <Stack direction="row" alignItems="center" gap={1.5}>
      <TextField
        type="number"
        size="small"
        value={values.recurrenceInterval}
        onChange={(e) => set("recurrenceInterval", Math.max(1, parseInt(e.target.value) || 1))}
        inputProps={{ min: 1, max: 365 }}
        sx={{ width: 80 }}
        error={!!errors.recurrenceInterval}
      />
      <Typography sx={{ fontSize: "13px", color: "#64748B", fontWeight: 500 }}>
        day{values.recurrenceInterval !== 1 ? "s" : ""}
      </Typography>
    </Stack>
  </Box>
);

export default DailyPicker;
